import { create } from 'zustand';

/**
 * Animator Control (Phase 2D) — pont interne entre ScreenApp (qui lit le signal
 * `stopRequest` dans Firestore) et le bridge de l'iframe (`useWebViewPlugin`, qui
 * poste l'ordre `remote-stop` dans le jeu). Jumeau de [[useRemoteLaunch]].
 *
 * `nonce` = horodatage du dernier appui « Stopper » relayé par l'écran (null tant
 * qu'aucun appui). Le producteur n'y pousse QUE les vrais appuis (il ignore la
 * valeur présente au montage → pas d'arrêt fantôme au rechargement de l'écran).
 */
type RemoteStopStore = {
    nonce: number | null;
    fire: (nonce: number) => void;
};

export const useRemoteStop = create<RemoteStopStore>((set) => ({
    nonce: null,
    fire: (nonce: number) => set({ nonce }),
}));
